import React,{useState} from 'react';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { AuthData } from '../../Services/Authdata';
import {AdminProfile} from '../../Services/AdminLogin';
import validateProfile from './UpdateValidation';
import useForm from './useForm';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
// import {Redirect} from 'react-router-dom';
export default function UpdateProfile(props){

  const [loader, setLoader] = useState("");
  const [action, setAction] = useState(false);
  const initialValues = {
		name: AuthData().name,
    email: AuthData().email,
  }
	const { values, errors, handleChange, handleSubmit } = useForm(initialValues,profile,validateProfile);
  const sendData = (message) => {
    props.parentCallback(message);
  }
	function profile() {
        setLoader(<CircularProgress color="secondary" style={{"position":"absolute",marginLeft:"50%",marginTop:'8%'}}/>)
        setTimeout(function(){
        setLoader("");
        AdminProfile('admin/updateProfile/'+AuthData().id,'POST',AuthData().token,values)
        .then((result)=>{
           // console.log(result);
            if(result.status === 1){
            sendData(<Alert variant="outlined" severity="success" style={{marginLeft:"2%",marginRight:"2%"}}> {result.message}</Alert>);
            sessionStorage.removeItem('userData');
            window.sessionStorage.setItem("userData", JSON.stringify(result.data));
            window.location.reload();
            }else{
            setAction(false);
            sendData(<Alert variant="outlined" severity="error" style={{marginLeft:"2%",marginRight:"2%"}}>{result.message}</Alert>)
            }
        });
        },2000)
    
	}
return (
    <div>
      {/* {loginMessage} */}
      {loader}
        {/* <form onSubmit={submitHandle}> */}

        <form onSubmit={handleSubmit} noValidate>
                  
            <FormControl style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                <TextField 
                id="name"
                error={errors.name?true:false}
                helperText={errors.name}
                label="Name"
                variant="outlined"
                type="text"
                name='name' 
                required
                size="small"
                onChange={handleChange}
                defaultValue={AuthData().name}
                />
            </FormControl>

            <FormControl style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                <TextField 
                error={errors.email?true:false}
                helperText={errors.email}
                id="email"
                label="Email"
                variant="outlined"
                type="email"
                name='email' 
                size="small"
                required
                onChange={handleChange}
                defaultValue={AuthData().email}
                />
            </FormControl>
            <FormControl style={{marginBottom:"5px"}}>
            <Button type="submit" disabled={action} variant="contained" color="primary" disableElevation>
            Save
            </Button>
            </FormControl>
        </form>
    </div>
)
}


// WEBPACK FOOTER //
// ./src/Pages/Auth/UpdateProfile.js